async function buildCartPermalink() {
  const res = await fetch('/cart.js');
  if (!res.ok) throw new Error('Unable to load cart');
  const cart = await res.json();

  const pairs = cart.items.map((item) => `${item.variant_id}:${item.quantity}`);

  if (pairs.length === 0) throw new Error('Cart is empty');

  return `${window.location.origin}/cart/${pairs.join(',')}`;
}

document.addEventListener('submit', async function (event) {
  const form = event.target.closest('#shareCart');
  if (!form) return;

  event.preventDefault();

  const cartLinkInput = document.getElementById('share-cart__link');
  const messageEl = document.getElementById('share-cart__message');

  messageEl.style.display = 'none';

  try {
    const cartLink = await buildCartPermalink();
    cartLinkInput.value = cartLink;

    const formData = new FormData(form);
    const payload = Object.fromEntries(formData.entries());

    const response = await fetch('/apps/share-cart', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) throw new Error('Failed to submit quote request');

    messageEl.textContent = 'Quote saved and email will be sent shortly.';
    messageEl.style.display = 'block';
    form.reset();
  } catch (err) {
    console.error(err);
    messageEl.textContent = 'There was an error saving the quote. Please try again.';
    messageEl.style.display = 'block';
  }
});
